import { Box, Heading, Text } from '@wix/design-system';
import s from './EmptyStateBanner.module.scss';

export interface EmptyStateBannerProps {
  children: React.ReactElement;
  title: string;
  dataHook?: string;
  isMobileView?: boolean;
}

export const EmptyStateBanner = ({
  children,
  title,
  dataHook,
  isMobileView,
}: EmptyStateBannerProps) => {
  if (isMobileView) {
    return (
      <Box direction="vertical" className={s.emptyStateBannerContainer}>
        <Text weight="bold" size="small">
          {title}
        </Text>
        {children}
      </Box>
    );
  }

  return (
    <Box
      direction="vertical"
      className={s.emptyStateBannerContainer}
      dataHook={dataHook}
    >
      <Heading as="h2" size="large" ellipsis>
        {title}
      </Heading>
      {children}
    </Box>
  );
};
